module.exports = __webpack_public_path__ + "img/t_defaultIcon.cd024962.png";